import store from "@/store";

/**
 * Resolve real-time transport for the current venue.
 * @returns {'sse'|'websocket'}
 */
export function resolveSyncTransport() {
	return store.getters["venue/sseEnabled"] ? "sse" : "websocket";
}

export default resolveSyncTransport;
